import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ObjectActions from '../user/actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from '../../shared/service/user/user.service';
import { userPreferencesActions } from './user-preferences.actions';

@Injectable()
export class UserPreferencesEffects {
  constructor(
    private actions$: Actions,
    public userService: UserService,
  ) {}

  upsertUserPreferences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userPreferencesActions.setPreferencesToDatabase.type),
      switchMap(({ preferences }: ReturnType<typeof userPreferencesActions.setPreferencesToDatabase>) => {
        return this.userService.upsertPreferences(preferences).pipe(
          switchMap(({ data }) => {
            return of(userPreferencesActions.setPreferencesToStore({ preferences: data.preferences }));
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes));
          }),
        );
      }),
    ),
  );
}
